module.exports = __webpack_public_path__ + "88089bb99034daa8e441e3ef2f4ddde4.pdf";